module.exports = __webpack_public_path__ + "img/logo-2.4f6ae675.png";